module.exports = __webpack_public_path__ + "static/img/MKD-logo.b93a00e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MKD-logo.png
// module id = 1240
// module chunks = 169